import { GlFormRadioGroup, GlFormRadio, GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__, sprintf } from '~/locale';
import glAbilitiesMixin from '~/vue_shared/mixins/gl_abilities_mixin';
import ConfirmActionModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/confirm_action_modal.vue?vue3';
import { getRegistryItem } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/item_type_registry.js?vue3';
import { canDeleteAiCatalogItem } from '../permissions';
export default {
    name: 'AiCatalogItemDeleteModal',
    components: {
        GlFormRadioGroup,
        GlFormRadio,
        GlSprintf,
        ConfirmActionModal
    },
    mixins: [
        glAbilitiesMixin()
    ],
    props: {
        item: {
            type: Object,
            required: true
        },
        deleteFn: {
            type: Function,
            required: true
        }
    },
    emits: [
        'close'
    ],
    data () {
        return {
            forceHardDelete: false
        };
    },
    computed: {
        itemRegistry () {
            return getRegistryItem(this.item.itemType);
        },
        canHardDelete () {
            return canDeleteAiCatalogItem({
                glAbilities: this.glAbilities
            });
        },
        itemTypeLabel () {
            return this.itemRegistry.label;
        },
        deleteConfirmTitle () {
            return this.canHardDelete ? sprintf(s__('AICatalog|Delete %{itemType}'), {
                itemType: this.itemTypeLabel
            }) : sprintf(s__('AICatalog|Hide %{itemType}'), {
                itemType: this.itemTypeLabel
            });
        },
        deleteConfirmMessage () {
            return this.canHardDelete ? s__('AICatalog|Are you sure you want to delete %{itemType} %{name}?') : s__('AICatalog|Are you sure you want to hide %{itemType} %{name}?');
        },
        deleteConfirmAdditionalMessage () {
            if (!this.canHardDelete) {
                return sprintf(s__('AICatalog|Users can continue to use the %{itemType} in the groups and projects it is enabled in.'), {
                    itemType: this.itemTypeLabel
                });
            }
            return null;
        }
    },
    created () {
        this.forceHardDelete = this.canHardDelete;
    }
};
